import { jsx as _jsx } from "react/jsx-runtime";
import { StyledBadgesWrapper, StyledButton } from './Tile.style';
import { Icon } from '../Icon';
export function TileButtons({ buttons, visible }) {
    return (_jsx(StyledBadgesWrapper, { visible: visible, children: buttons.map((button, index) => (_jsx(StyledButton, { children: _jsx(Icon, { name: button.name, size: button.size }) }, `tile-badge-${button.name}-${index}`))) }));
}
//# sourceMappingURL=TileButtons.js.map